import React from 'react';
import styled from 'styled-components';
import Wave from '../../assets/img/wave.svg';

const RangeSliderWrapper = styled.div`
	margin: 4em 10px;
	position: relative;
`;

const InputRange = styled.input`
	-webkit-appearance: none;
	background-color: transparent;
    background-image: url(${Wave});
	cursor: pointer;
	height: 4px;
	width: 100%;

	&::-webkit-slider-thumb {
		-webkit-appearance: none;
		background-color: #669d9e;
		opacity: 1;
        border: none;
		border-radius: 30px;
		width: 26px;
		height: 26px;

		&:after {
			content: "";
            display:block
			background-color: #669d9e;
			width: 50px;
			height: 50px;
		}
	}
`;

const YearLabel = styled.small`
	position: absolute;
	top: -35px;

	${(props) => (props.left ? 'left: 0;' : 'right: 0;')};
`;

const RangeSlider = ({value, handleChange}) => {
	return (
		<RangeSliderWrapper>
			<YearLabel left>2020</YearLabel>
			<YearLabel right>2021</YearLabel>
			<InputRange type="range" name="production" className="slider" min="0" max="7" value={value} onChange={handleChange} />
		</RangeSliderWrapper>
	);
};

export default RangeSlider;
